import { Mixpanel } from "./mixpanel";
import { CustomEventProps } from "./types";

export const mixpanelCustomEvent = ({
  mixpanelProps = {},
  id,
  eventName,
}: CustomEventProps) => {
  try {
    if (id) {
      Mixpanel.identify(id.toString());
    }
    Mixpanel.track(eventName, mixpanelProps);
  } catch (err) {
    console.error(`Mixpanel tracking error: ${err}`);
  }
};
